import { authStore } from '../store/auth.store.js';
const BASE_URL = 'https://amaze.omly.live/api/v1';
export async function apiRequest(path, options = {}) {
    const { method = 'GET', body, auth = false } = options;
    const headers = {
        'Content-Type': 'application/json',
    };
    if (auth) {
        const token = authStore.getToken();
        if (!token)
            throw new Error('Not authenticated');
        headers['Authorization'] = `Bearer ${token}`;
    }
    const response = await fetch(`${BASE_URL}${path}`, {
        method,
        headers,
        body: body ? JSON.stringify(body) : undefined,
    });
    if (response.status === 204)
        return undefined;
    const data = await response.json();
    if (!response.ok) {
        throw new Error(data.message ?? 'Request failed');
    }
    return data;
}
